import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { geolocationDetector } from './utils/geolocationDetector';

// Import all translation namespaces
import enCommon from './locales/en/common.json';
import enChart from './locales/en/chart.json';
import enPolitician from './locales/en/politician.json';
import enMeta from './locales/en/meta.json';
import enLeaderboard from './locales/en/leaderboard.json';
import enNews from './locales/en/news.json';
import enShareCard from './locales/en/shareCard.json';

import zhCNCommon from './locales/zh-CN/common.json';
import zhCNChart from './locales/zh-CN/chart.json';
import zhCNPolitician from './locales/zh-CN/politician.json';
import zhCNMeta from './locales/zh-CN/meta.json';
import zhCNLeaderboard from './locales/zh-CN/leaderboard.json';
import zhCNNews from './locales/zh-CN/news.json';
import zhCNShareCard from './locales/zh-CN/shareCard.json';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWChart from './locales/zh-TW/chart.json';
import zhTWPolitician from './locales/zh-TW/politician.json';
import zhTWMeta from './locales/zh-TW/meta.json';
import zhTWLeaderboard from './locales/zh-TW/leaderboard.json';
import zhTWNews from './locales/zh-TW/news.json';
import zhTWShareCard from './locales/zh-TW/shareCard.json';

// Configure language detector with custom geolocation detector
const languageDetector = new LanguageDetector();
languageDetector.addDetector(geolocationDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        chart: enChart,
        politician: enPolitician,
        meta: enMeta,
        leaderboard: enLeaderboard,
        news: enNews,
        shareCard: enShareCard,
      },
      'zh-CN': {
        common: zhCNCommon,
        chart: zhCNChart,
        politician: zhCNPolitician,
        meta: zhCNMeta,
        leaderboard: zhCNLeaderboard,
        news: zhCNNews,
        shareCard: zhCNShareCard,
      },
      'zh-TW': {
        common: zhTWCommon,
        chart: zhTWChart,
        politician: zhTWPolitician,
        meta: zhTWMeta,
        leaderboard: zhTWLeaderboard,
        news: zhTWNews,
        shareCard: zhTWShareCard,
      },
    },
    fallbackLng: {
      'zh-TW': ['zh-CN', 'en'],
      'zh-CN': ['en'],
      'default': ['en'],
    },
    defaultNS: 'common',
    ns: ['common', 'chart', 'politician', 'meta', 'leaderboard', 'news', 'shareCard'],

    detection: {
      // Order matters: custom geolocation first, then fallbacks
      order: [
        'localStorage',        // Check if user already has preference
        'geolocation',         // Custom geolocation detector
        'navigator',           // Browser language
        'htmlTag',            // <html lang=""> attribute
      ],
      lookupLocalStorage: 'capitol-trades-language',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'], // Don't cache in dev mode
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true, // Use Suspense for loading translations
    },

    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;
